/**
 * Polyfill for 'fs' module used by face-api.js
 * This provides a mock implementation for browser environment
 */

if (typeof (window as any).fs === 'undefined') {
  (window as any).fs = {
    readFileSync: () => {
      throw new Error('fs.readFileSync is not available in browser environment');
    },
    writeFileSync: () => {
      throw new Error('fs.writeFileSync is not available in browser environment');
    },
    existsSync: () => false,
    promises: {
      readFile: () => Promise.reject(new Error('fs.promises.readFile is not available in browser environment')),
      writeFile: () => Promise.reject(new Error('fs.promises.writeFile is not available in browser environment')),
    },
  };
}

export {};
